var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircleRainbow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.875 24.643V26.5417C42.8698 35.5836 36.918 43.5451 28.2471 46.1088C19.5763 48.6725 10.252 45.2277 5.33065 37.6424C0.40934 30.0571 1.06338 20.1383 6.9381 13.2649C12.8128 6.39148 22.5087 4.20081 30.7679 7.88087",
    stroke: "url(#paint0_linear_468_1609)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9168 8.16699L22.4585 30.6253L16.3335 24.5003",
    stroke: "url(#paint1_linear_468_1609)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_1609",
    x1: 2.0415,
    y1: 46.9483,
    x2: 51.0558,
    y2: 27.7422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#E23B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998652,
    stopColor: "#AE04FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998752,
    stopColor: "#AE04FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_468_1609",
    x1: 16.3335,
    y1: 30.6253,
    x2: 48.0276,
    y2: 14.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#E23B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998652,
    stopColor: "#AE04FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998752,
    stopColor: "#AE04FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleRainbow);
export default __webpack_public_path__ + "static/media/check-circle-rainbow.f9e6fcc3.svg";
export { ForwardRef as ReactComponent };